<template>
  <div class="_modals">
    <b-modal id="bookingform__address"
      ref="modalFormAddrAdd"
      centered
      hide-footer
      @hide="resetFetchAfterModalClosed"
      :title="typeMethod === 'add' ? 'Add New Address' : 'Edit Address'">
      <b-form novalidate>
        <div class="row m-0">
          <div class="col-md p-0 pr-2">
            <b-form-group
              :label="`${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} PIC Name`"
              class="mb-2" >
              <b-form-input
                v-validate="'required'"
                name="pic name"
                :state="errors.first('pic name') && false"
                v-model="formAddress.picName"
                type="text"
                :placeholder="`Insert ${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} PIC Full Name`"
              ></b-form-input>
              <p v-if="errors.has('pic name')" class="fontstyle__errormsg">
                        {{ errors.first('pic name') }}
              </p>
            </b-form-group>
            <div class="mb-2">
              <p>Country</p>
              <v-select
                v-model="codeCountry"
                :options="countryList"
                label="name"
                name='country'
                v-validate="'required'"
                placeholder="Country"
                :clearable="false"
                @input="chkLocation('country')"
              />
               <p v-if="errors.has('country')" class="fontstyle__errormsg">
                  {{ errors.first('country') }} </p>
            </div>
            <div class="mb-2">
              <p>City</p>
              <v-select
                v-model="codeCity"
                :options="cityList"
                label="name"
                name='city'
                v-validate="'required'"
                placeholder="City"
                :clearable="false"
                @input="chkLocation('city')"
              />
               <p v-if="errors.has('city')" class="fontstyle__errormsg">
                  {{ errors.first('city') }} </p>
            </div>
            <b-form-group
              label="ZIP Code"
              class="mb-2" >
              <b-form-input
                v-validate="'required'"
                name="zip code"
                :state="errors.first('zip code') && false"
                v-model="formAddress.zipCode"
                type="number"
                placeholder="ZIP Code"
              ></b-form-input>
              <p v-if="errors.has('zip code')" class="fontstyle__errormsg">
                        {{ errors.first('zip code') }}
              </p>
            </b-form-group>
            <div>
              <label>Phone Number</label>
              <div class="phone__wrapper" style="margin-bottom: 0px">
                <div class="col-4" style="padding: 0px">
                  <v-select
                    v-model="phoneCode"
                    :options="optionDialCode || []"
                    v-validate="'required'"
                    label="phonecode"
                    name='phone code'
                    placeholder="Code"
                    class="phone__code"
                    :clearable="false"
                    @input="chkPhoneCode()"
                  >
                    <template slot="option" slot-scope="option">+{{ option.phonecode }}</template>
                    <template slot="selected-option" slot-scope="option">+{{ option.phonecode }}</template>
                  </v-select>
                </div>
                <b-form-group id="input-group-1" label-for="input-1" class="col-8" style="margin-bottom: 0px; padding: 0px">
                  <b-form-input
                    v-model="formAddress.phoneNumber"
                    v-validate="'required'"
                    name="phone number"
                    type="number"
                    :state="errors.first('phone number') && false"
                    required
                    :placeholder="`${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} PIC Phone Number`"
                  ></b-form-input>
                </b-form-group>
              </div>
              <p v-if="errors.has('phone code')" class="fontstyle__errormsg">
                {{ errors.first('phone code') }}
              </p>
              <p v-if="errors.has('phone number')" class="fontstyle__errormsg">
                {{ errors.first('phone number') }}
              </p>
            </div>
          </div>
          <div class=" col-md p-0 pl-2">
            <b-form-group
              label="Company Name"
              class="mb-2">
              <b-form-input
                v-validate="'required'"
                name="company name"
                :state="errors.first('company name') && false"
                v-model="formAddress.companyName"
                type="text"
                :placeholder="`${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} Company Name`"
              ></b-form-input>
              <p v-if="errors.has('company name')" class="fontstyle__errormsg">
                        {{ errors.first('company name') }}
              </p>
            </b-form-group>
            <b-form-group
              label="Company Address"
              class="mb-2" >
              <b-form-textarea
                id="textarea"
                name="company address"
                v-model="formAddress.companyAddress"
                :state="errors.first('company address') && false"
                v-validate="'required'"
                :placeholder="`${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} Company Address`"
                max-rows="6"
              ></b-form-textarea>
              <p v-if="errors.has('company address')" class="fontstyle__errormsg">
                        {{ errors.first('company address') }}
              </p>
            </b-form-group>
            <b-form-group
              class="mb-2" >
              <div class="row m-0 justify-content-between align-items-end">
                <label>Company Tax ID</label>
                <small>*Optional</small>
              </div>
              <b-form-input
                name="comapnyTaxId"
                v-model="formAddress.companyTaxId"
                type="text"
                placeholder="Company Tax Id"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Email"
              class="mb-2" >
              <b-form-input
                v-validate="'email'"
                name="email"
                :state="errors.first('email') && false"
                v-model="formAddress.email"
                type="text"
                :placeholder="`Insert ${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} PIC Email Address`"
              ></b-form-input>
              <p v-if="errors.has('email')" class="fontstyle__errormsg">
                        {{ errors.first('email') }}
              </p>
            </b-form-group>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md text-right">
            <button
               type="button"
               class="button__bluecorporite"
               @click="saveAddr()"
               :disabled="isCreating || isLoadingEditAddress">
               <span v-if="isCreating || isLoadingEditAddress">
                 <b-spinner small variant="light" label="Spinning" />
               </span>
               <span v-else>
                 Save Address
               </span>
            </button>
          </div>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="bookingform__chooseaddress"
      ref="modalFormAddrChoose"
      centered
      hide-footer
      @hide="resetFetchAfterModalClosed"
      :title="`Choose ${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} Address`">
      <div class="d-flex flex-column align-items-start mb-3">
        <b-form-group class="w-100 mb-2 input__search">
          <b-form-input
            v-model="searchAddress"
            name="search"
            type="text"
            :placeholder="`Search by ${typeAddress === 'shipper' ? 'Shipper' : 'Consignee'} PIC Name/Company Name/Company Address`"
            class="mt-1"
            @input="debouncedOnChange"
          ></b-form-input>
          <div class="search__box">
            <img src="@/assets/image/icon/search.svg" alt="icon-search">
          </div>
        </b-form-group>
        <!-- <input type="text" class="input__search" placeholder="Search by Shipper PIC Name/Company Name/Company"> -->
        <button class="button__borderblueround" style="margin: 0" @click="showFormAddress()">+ Add Address</button>
      </div>
      <div v-if="!isLoadingShipperList && !isLoadingConsigneeList">
        <div v-if="searchAddress.length && (typeAddress === 'shipper' ? shipperList.length : consigneeList.length)" class="result__search">
          <span>The results for "{{searchAddress}}"</span>
        </div>
      </div>
      <div class="custom__radio1">
        <div v-if="isLoadingShipperList || isLoadingConsigneeList">
          <div class="col-md-12" >
            <half-circle-spinner
              :animation-duration="750"
              :size="100"
              color="#1D3354"
              class="mx-auto"
            />
          </div>
        </div>
        <div v-else-if="!isLoadingShipperList && !isLoadingConsigneeList">
          <div v-if="typeAddress === 'shipper' ? tempShipperList.length > 0 : tempConsigneeList.length > 0">
            <b-form-group v-for="item in typeAddress === 'shipper' ? shipperList : consigneeList" v-bind:key="item.id">
              <b-form-radio v-model="selectedAddr" :value="item.id">
                <div class="row m-0">
                  <b class="col-md-4 p-0">{{typeAddress === 'shipper' ? 'Shipper' : 'Consignee'}} PIC Name</b>
                  <b class="col-md p-0 d-flex justify-content-between">
                    : {{item.fullname}}
                    <div>
                      <span class="pl-2" style="cursor: pointer;"
                        @click.prevent="modifAddress(typeAddress === 'shipper' ? 'shipper' : 'consignee', 'edit', item.id )"
                        @mouseover="hoverEdit = true, hoverId = item.id"
                        @mouseleave="hoverEdit = false, hoverId = ''">
                        <img class="mr-1" src="@/assets/image/icon/pencil-blue-hover.svg" alt="" v-if="hoverEdit && hoverId === item.id">
                        <img class="mr-1" src="@/assets/image/icon/pencil-blue.svg" alt="" v-else>
                      </span>
                      <span class="pl-1" style="cursor: pointer;"
                        @click.prevent="dialogAddrDelete(item.id)"
                        @mouseover="hoverDelete = true, hoverId = item.id"
                        @mouseleave="hoverDelete = false, hoverId = ''">
                        <img class="mr-1" src="@/assets/image/icon/bin-red.svg" alt="" v-if="hoverDelete && hoverId === item.id">
                        <img class="mr-1" src="@/assets/image/icon/bin-blue.svg" alt="" v-else>
                      </span>
                    </div>
                  </b>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">Company Name</p>
                  <p class="col-md p-0">: {{item.company_name || "-"}}</p>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">Phone</p>
                  <p class="col-md p-0">: {{item.phone_code}}{{item.phone_number}}</p>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">Email</p>
                  <p class="col-md p-0">: {{item.email || "-"}}</p>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">ZIP Code</p>
                  <p class="col-md p-0">: {{item.zip_code || "-"}}</p>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">Company Tax Id</p>
                  <p class="col-md p-0">: {{item.company_tax_id || "-"}}</p>
                </div>
                <div class="row m-0">
                  <p class="col-md-4 p-0">Company Address</p>
                  <p class="col-md p-0 __preline">: {{item.address || "-"}}</p>
                </div>
              </b-form-radio>
            </b-form-group>
          </div>
          <div v-else class="result__search d-flex flex-column align-items-center">
            <img src="@/assets/image/icon/noresult-search-address.svg" alt="icon-noresult-search-address" class="mb-2">
            <span class="mb-2">The Address contain “{{searchAddress}}” is not available on the addresses list</span>
            <button class="button__borderblueround mb-5" style="margin: 0; width: fit-content" @click="backToSearching">Back to Searching</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md text-center">
          <button class="button__bluecorporite" :disabled="!selectedAddr" @click="submitAddr()">
            Submit Address
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal class="bookingform__address_message"
      ref="modalFormAddrChooseMessage"
      centered
      hide-footer
      title="">
      <div class="custom__radio1">
        <div class="" v-if="isCreating">
          <div class="col-md-12" >
            <half-circle-spinner
              :animation-duration="750"
              :size="100"
              color="#1D3354"
              class="mx-auto"
            />
          </div>
        </div>
        <div v-else>
          <h5 class="text-center">
            {{ messageInfo }}
          </h5>
        </div>
        <div class="row mt-4">
          <div class="col-md text-center">
            <button
              @click="closeModal()" class="button__bluecorporite">OK
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="bookingform__delete"
      ref="modalFormAddrDelete"
      centered
      hide-footer>
      <div>
        <p>Are you sure want to delete details?</p>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <button class="button__bluecorporite mr-3" @click="deleteAddr(idAddr)">Yes</button>
        <button class="button__redcorporite" @click="closeModalDelete">No</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import _ from 'lodash'

export default {
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      selectedAddr: 0,
      formAddTemp: {},
      formAddress: {
        picName: '',
        phoneCode: '',
        phoneNumber: '',
        companyName: '',
        companyAddress: '',
        codeCity: '',
        zipCode: '',
        companyTaxId: '',
        type: '',
        codeCountry: '',
        email: ''
      },
      messageInfo: '',
      typeAddress: '',
      codeCountry: '',
      codeCity: '',
      phoneCode: '',
      error: {},
      scrollTarget: '',
      typeMethod: '',
      idAddr: '',
      hoverEdit: false,
      hoverDelete: false,
      hoverId: '',
      searchAddress: '',
      optionDialCode: [],
      tempShipperList: [],
      tempConsigneeList: [],
      selectedForm: {}
    }
  },
  computed: {
    ...mapGetters({
      isAuth: 'auth/isAuth',
      // address shipper list
      shipperList: 'address/shipperList',
      isLoadingShipperList: 'address/isLoadingShipperList',
      errorShipperList: 'address/errorShipperList',
      // address consignee list
      consigneeList: 'address/consigneeList',
      isLoadingConsigneeList: 'address/isLoadingConsigneeList',
      errorConsigneeList: 'address/errorConsigneeList',
      // create address
      isCreated: 'address/isCreated',
      errorCreated: 'address/errorCreated',
      isCreating: 'address/isCreating',
      // edit address
      editAddress: 'address/editAddress',
      isLoadingEditAddress: 'address/isLoadingEditAddress',
      errorEditAddress: 'address/errorEditAddress',
      // data temp
      queryData: 'book/dataTemp',
      // country & city data
      cityList: 'city/city',
      countryList: 'city/country',
      isCityLoading: 'city/isLoading',
      // phone code
      dialcode: 'auth/dialcode',
      isLoadingDialcode: 'auth/isLoadingDialcode',
      addressData: 'address/dataAddressTemp'
    }),
    countries () {
      return this.formAddress.codeCountry
    },
    cities () {
      return this.formAddress.codeCity
    },
    debouncedOnChange () {
      return _.debounce(this.searchOnChange, 700)
    }
  },
  mounted () {
    if (this.isAuth) {
      this.$store.dispatch('city/FETCH_COUNTRIES')
      this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
    }
  },
  watch: {
    shipperList (data) {
      this.tempShipperList = data
    },
    consigneeList (data) {
      this.tempConsigneeList = data
    },
    isAuth (data) {
      if (data) {
        this.$store.dispatch('city/FETCH_COUNTRIES')
      }
    },
    idAddr (data) {
      if (data && this.typeMethod === 'edit') {
        if (this.typeAddress === 'consignee') {
          this.inputFormAddress(this.consigneeList)
        } else {
          this.inputFormAddress(this.shipperList)
        }
      }
    },
    codeCountry (data, oldData) {
      if (data) {
        this.$store.dispatch('city/FETCH_CITIES', data.code)
      }
    },
    cityList (data) {
      if (data && data.length > 0) {
        data.forEach(item => {
          if (item.code === this.formAddress.codeCity) {
            this.codeCity = { name: item.name }
          }
        })
      }
    },
    editAddress (data) {
      if (data) {
        this.inputDataTemp(data, 'edit')
      }
    },
    isCreated (data) {
      if (data) {
        this.inputDataTemp(data, 'add')
      }
    },
    errorCreated (data) {
      if (data) {
        this.messageInfo = 'Failed'
        this.$refs.modalFormAddrAdd.hide()
        this.$refs.modalFormAddrChoose.hide()
        this.$refs.modalFormAddrChooseMessage.show()
      }
    },
    dialcode (data) {
      if (data) {
        this.optionDialCode = data.data
      }
    }
  },
  created () {
    this.$eventHub.$on('dialog-form-address-add', this.dialogAddrAdd)
    this.$eventHub.$on('dialog-form-address-choose', this.dialogAddrChoose)
    this.$eventHub.$on('dialog-form-address-delete', this.dialogAddrDelete)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-form-address-add')
    this.$eventHub.$off('dialog-form-address-choose')
    this.$eventHub.$off('dialog-form-address-delete')
  },
  methods: {
    chkLocation (type) {
      // checking type
      const form = this.formAddress
      if (type === 'country') {
        form.codeCountry = this.codeCountry.code
        form.codeCity = ''
        this.codeCity = ''
      } else if (type === 'city') {
        form.codeCity = this.codeCity.code
      }
    },
    chkPhoneCode () {
      // checking type
      const form = this.formAddress
      if (this.phoneCode.phonecode) {
        form.phoneCode = `+${Number(this.phoneCode.phonecode)}`
      }
    },
    showFormAddress () {
      this.$refs.modalFormAddrChoose.hide()
      this.dialogAddrAdd({type: this.typeAddress, method: 'add'})
    },
    closeModal () {
      this.$refs.modalFormAddrAdd.hide()
      this.$refs.modalFormAddrChoose.hide()
      this.$refs.modalFormAddrChooseMessage.hide()
      this.$refs.modalFormAddrDelete.hide()
    },
    dialogAddrAdd ({type, method, idAddr}) {
      this.idAddr = '' // init
      this.typeMethod = '' // init
      if (method === 'add') { // reset formAddress when user choose add new address
        this.codeCountry = ''
        this.codeCity = ''
        this.phoneCode = ''
        this.formAddress = {}
      }
      this.formAddress.type = type
      this.typeAddress = type
      this.typeMethod = method
      this.idAddr = idAddr

      this.$refs.modalFormAddrAdd.show()
    },
    async inputDataTemp (data, type) {
      this.messageInfo = `Address has been successfully ${type === 'add' ? 'saved' : 'edited'}`
      if ((this.typeMethod === 'edit' && this.typeAddress === 'shipper') ||
      (this.typeMethod === 'add' && this.shipperList.length < 1 && this.typeAddress === 'shipper')) {
        this.formAddTemp.shipper_name = data.picName
        this.formAddTemp.shipper_comp = data.companyName
        this.formAddTemp.shipper_address = data.companyAddress
        this.formAddTemp.shipper_phone = data.phoneNumber
        this.formAddTemp.shipper_phonecode = data.phoneCode
        this.formAddTemp.shipper_email = data.email
        this.formAddTemp.shipper_zip_code = data.zipCode
        this.formAddTemp.shipper_company_tax_id = data.companyTaxId
        await this.$store.dispatch('address/POST_DATA_ADDRESS_TEMP', this.formAddTemp)
      }
      if ((this.typeMethod === 'edit' && this.typeAddress === 'consignee') ||
      (this.typeMethod === 'add' && this.consigneeList.length < 1 && this.typeAddress === 'consignee')) {
        this.formAddTemp.consignee_name = data.picName
        this.formAddTemp.consignee_comp = data.companyName
        this.formAddTemp.consignee_address = data.companyAddress
        this.formAddTemp.consignee_phone = data.phoneNumber
        this.formAddTemp.consignee_phonecode = data.phoneCode
        this.formAddTemp.consignee_email = data.email
        this.formAddTemp.consignee_zip_code = data.zipCode
        this.formAddTemp.consignee_company_tax_id = data.companyTaxId
        await this.$store.dispatch('address/POST_DATA_ADDRESS_TEMP', this.formAddTemp)
      }
      await this.$store.dispatch('address/FETCH_ADDRESS_SHIPPER', 'shipper')
      await this.$store.dispatch('address/FETCH_ADDRESS_CONSIGNEE', 'consignee')
      this.$refs.modalFormAddrAdd.hide()
      this.$refs.modalFormAddrChoose.hide()
      this.$refs.modalFormAddrChooseMessage.show()
    },
    inputFormAddress (data) { // input data to formAddess when edit address
      data.forEach(async item => {
        if (item.id === this.idAddr) {
          this.formAddress.id = item.id
          this.formAddress.picName = item.fullname
          this.formAddress.phoneNumber = item.phone_number
          this.formAddress.companyName = item.company_name
          this.formAddress.companyAddress = item.address
          this.formAddress.zipCode = item.zip_code
          this.formAddress.companyTaxId = item.company_tax_id
          this.formAddress.type = this.typeAddress
          this.formAddress.codeCountry = item.code_country
          await this.$store.dispatch('city/FETCH_CITIES', item.code_country)
          this.countryList.forEach(country => {
            if (country.code === item.code_country) {
              this.codeCountry = { name: country.name, code: country.code }
            }
          })
          this.cityList.forEach(city => {
            if (city.code === item.code_city) {
              this.formAddress.codeCity = item.code_city
              this.codeCity = city.name
            }
          })
          this.optionDialCode.forEach(code => {
            if (item.phone_code) {
              if (Number(code.phonecode) === Number(item.phone_code)) {
                this.formAddress.phoneCode = `+${Number(item.phone_code)}`
                this.phoneCode = code
              }
            } else {
              this.formAddress.phoneCode = item.phone_code
              this.phoneCode = item.phone_code
            }
          })
          this.formAddress.email = item.email
        }
      })
    },
    dialogAddrChoose ({ type, selectedForm }) {
      this.typeAddress = type
      this.formAddress.type = type
      this.formAddTemp.typeAddress = type
      this.selectedForm = selectedForm
      let tempShipper = this.shipperList.find(el => el.company_name === selectedForm.shipper_comp && el.fullname === selectedForm.shipper_name && el.email === selectedForm.shipper_email) || null
      let tempConsignee = this.consigneeList.find(el => el.company_name === selectedForm.consignee_comp && el.fullname === selectedForm.consignee_name && el.email === selectedForm.consignee_email) || null
      if (type === 'shipper') {
        if (tempShipper) {
          this.selectedAddr = tempShipper.id
        }
      } else if (type === 'consignee') {
        if (tempConsignee) {
          this.selectedAddr = tempConsignee.id
        }
      }
      this.$refs.modalFormAddrChoose.show()
    },
    saveAddr () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addAddress(this.formAddress)
        }
      })
    },
    async addAddress (payload) {
      if (this.typeMethod === 'edit') {
        await this.$store.dispatch('address/EDIT_ADDRESS', payload)
      } else {
        await this.$store.dispatch('address/CREATE_ADDRESS', payload)
      }
    },
    async submitAddr () {
      const addressId = this.selectedAddr
      if (this.typeAddress === 'consignee') {
        _.map(this.consigneeList, (el) => {
          if (parseInt(el.id) === parseInt(addressId)) {
            this.formAddTemp.id = el.id
            this.formAddTemp.consignee_name = el.fullname
            this.formAddTemp.consignee_comp = el.company_name
            this.formAddTemp.consignee_address = el.address
            this.formAddTemp.consignee_phone = el.phone_number
            this.formAddTemp.consignee_phonecode = el.phone_code
            this.formAddTemp.shipper_notes = ''
            this.formAddTemp.consignee_email = el.email
            this.formAddTemp.consignee_zip_code = el.zip_code
            this.formAddTemp.consignee_company_tax_id = el.company_tax_id
          }
        })
      }
      if (this.typeAddress === 'shipper') {
        _.map(this.shipperList, (el) => {
          if (parseInt(el.id) === parseInt(addressId)) {
            this.formAddTemp.id = el.id
            this.formAddTemp.shipper_name = el.fullname
            this.formAddTemp.shipper_comp = el.company_name
            this.formAddTemp.shipper_address = el.address
            this.formAddTemp.shipper_phone = el.phone_number
            this.formAddTemp.shipper_phonecode = el.phone_code
            this.formAddTemp.shipper_notes = ''
            this.formAddTemp.shipper_email = el.email
            this.formAddTemp.shipper_zip_code = el.zip_code
            this.formAddTemp.shipper_company_tax_id = el.company_tax_id
          }
        })
      }
      await this.$store.dispatch('address/POST_DATA_ADDRESS_TEMP', this.formAddTemp)
      this.formAddress = {
        picName: '',
        phoneNumber: '',
        phoneCode: '',
        companyName: '',
        companyAddress: '',
        codeCity: '',
        zipCode: '',
        companyTaxId: '',
        type: ''
      }
      this.$refs.modalFormAddrChoose.hide()
    },
    async deleteAddr (id) {
      let tempSelectedAddr = this.shipperList.find(el => el.id === id) || this.consigneeList.find(el => el.id === id)
      await this.$store.dispatch('address/DELETE_ADDRESS', id)
      this.$refs.modalFormAddrDelete.hide()
      if (this.typeAddress === 'shipper') {
        await this.$store.dispatch('address/FETCH_ADDRESS_SHIPPER', 'shipper')
        if (this.selectedForm.shipper_comp === tempSelectedAddr.company_name && this.selectedForm.shipper_email === tempSelectedAddr.email) {
          await this.$store.dispatch('address/POST_DATA_ADDRESS_TEMP', { typeAddress: 'shipper' })
        }
        if (this.shipperList.length === 0) {
          this.$refs.modalFormAddrChoose.hide()
        }
      } else {
        await this.$store.dispatch('address/FETCH_ADDRESS_CONSIGNEE', 'consignee')
        if (this.selectedForm.consignee_comp === tempSelectedAddr.company_name && this.selectedForm.consignee_email === tempSelectedAddr.email) {
          await this.$store.dispatch('address/POST_DATA_ADDRESS_TEMP', { typeAddress: 'consignee' })
        }
        if (this.consigneeList.length === 0) {
          this.$refs.modalFormAddrChoose.hide()
        }
      }
    },
    searchOnChange () {
      if (this.typeAddress === 'consignee') {
        this.$store.dispatch('address/CONSIGNEE_SEARCH_ADDRESS', this.searchAddress)
      } else if (this.typeAddress === 'shipper') {
        this.$store.dispatch('address/SHIPPER_SEARCH_ADDRESS', this.searchAddress)
      }
    },
    backToSearching () {
      this.searchAddress = ''
      this.searchOnChange()
    },
    modifAddress (type, method, idAddr) {
      this.$eventHub.$emit('dialog-form-address-add', {type, method, idAddr})
    },
    dialogAddrDelete (id) {
      this.idAddr = id
      this.$refs.modalFormAddrDelete.show()
    },
    closeModalDelete () {
      this.$refs.modalFormAddrDelete.hide()
    },
    resetFetchAfterModalClosed () {
      this.$store.dispatch('address/FETCH_ADDRESS_SHIPPER', 'shipper')
      this.$store.dispatch('address/FETCH_ADDRESS_CONSIGNEE', 'consignee')
      this.searchAddress = ''
      this.idAddr = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/FormBooking.vue